import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Preloader from "@/components/Preloader";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Activities from "@/pages/Activities";
import OMDigital from "@/pages/OMDigital";
import TrackRecord from "@/pages/TrackRecord";
import Governance from "@/pages/Governance";
import InvestorRelations from "@/pages/InvestorRelations";
import News from "@/pages/News";
import Downloads from "@/pages/Downloads";
import Contact from "@/pages/Contact";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <Preloader />
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/activities" element={<Activities />} />
          <Route path="/om-digital" element={<OMDigital />} />
          <Route path="/esperienza-internazionale" element={<TrackRecord />} />
          <Route path="/governance" element={<Governance />} />
          <Route path="/news" element={<News />} />
          <Route path="/downloads" element={<Downloads />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
